export default "__VITE_ASSET__BDb$4EPH__"